/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMap, values } from '@client/new/helpers/types-utils';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { _noop } from '@client/new/helpers/general';

export type FormMapType = ReturnType<typeof useFormMap>;

export const useFormMap = () => {
  const [formMap, setFormMap] = useMap<UseFormReturn>();
  const isValid = () => values(formMap).every((vm) => (vm as any).isValid);

  const getErrors = () =>
    values(formMap)
      .flatMap((vm) => (vm as any).getErrors?.() ?? [])
      .filter(Boolean);

  const addForm = <T extends FieldValues>(id: string, data: UseFormReturn<T>) =>
    setFormMap((v) => ({ ...v, [id]: data as any }));

  const removeForm = (id: string) =>
    setFormMap((v) => {
      const { [id]: _, ...rest } = v;
      return rest;
    });

  const reset = () => {
    setFormMap({});
  };

  return {
    addForm,
    removeForm,
    isValid,
    getErrors,
    formMap,
    reset,
  };
};
